// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-splash-screen {
  background:rgb(0, 0, 0);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  z-index: 100;
}

.app-loader {
  background: url('oval.svg');
  background-repeat: no-repeat;
  max-width: 100%;
  background-position: center;
  background-size: contain;
  width: 120px;
  height: 120px;
  margin-top: 50px;
}

.app-label {
  margin-top: 32px;
  color: #fff;
  font-size: 2.5em;
}

.app-splash-inner {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.app-logo {
  background: url('icon-512x512.png');
  background-repeat: no-repeat;
  max-width: 100%;
  background-position: center;
  background-size: contain;
  width: 100px;
  height: 100px;
}

.message-main {
  opacity: 0;
  transition: 2s opacity;
}

.message-show {
  opacity: 1;
}

.message-hide {
  opacity: 0;
}

.modalLogin {
  color: #a94442;
  background-color: #f2dede;
  border-color: #ebccd1;
  padding: 15px;
  margin-bottom: 20px;
  border: 1px solid transparent;
  border-radius: 4px;
}
`, "",{"version":3,"sources":["webpack://./src/app/core/loading-po-sync/loading-po-sync.component.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,2BAA+C;EAC/C,4BAA4B;EAC5B,eAAe;EACf,2BAA2B;EAC3B,wBAAwB;EACxB,YAAY;EACZ,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,mCAA2D;EAC3D,4BAA4B;EAC5B,eAAe;EACf,2BAA2B;EAC3B,wBAAwB;EACxB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,kBAAkB;AACpB","sourcesContent":[".app-splash-screen {\n  background:rgb(0, 0, 0);\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  height: 100%;\n  z-index: 100;\n}\n\n.app-loader {\n  background: url(\"../../../assets/svg/oval.svg\");\n  background-repeat: no-repeat;\n  max-width: 100%;\n  background-position: center;\n  background-size: contain;\n  width: 120px;\n  height: 120px;\n  margin-top: 50px;\n}\n\n.app-label {\n  margin-top: 32px;\n  color: #fff;\n  font-size: 2.5em;\n}\n\n.app-splash-inner {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n\n.app-logo {\n  background: url(\"./../../../assets/icons/icon-512x512.png\");\n  background-repeat: no-repeat;\n  max-width: 100%;\n  background-position: center;\n  background-size: contain;\n  width: 100px;\n  height: 100px;\n}\n\n.message-main {\n  opacity: 0;\n  transition: 2s opacity;\n}\n\n.message-show {\n  opacity: 1;\n}\n\n.message-hide {\n  opacity: 0;\n}\n\n.modalLogin {\n  color: #a94442;\n  background-color: #f2dede;\n  border-color: #ebccd1;\n  padding: 15px;\n  margin-bottom: 20px;\n  border: 1px solid transparent;\n  border-radius: 4px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
